import { render, staticRenderFns } from "./CustomSpinner.vue?vue&type=template&id=ec0b0566"
import script from "./CustomSpinner.vue?vue&type=script&lang=js"
export * from "./CustomSpinner.vue?vue&type=script&lang=js"
import style0 from "./CustomSpinner.vue?vue&type=style&index=0&id=ec0b0566&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports